import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import "./Header.css";

const Header = ({ logoAlt, menuColor2, contactStyle, navbar }) => {
  const navigate = useNavigate();

  const navBarRef = useRef(null);

  const closeMenu = () => {
    const collapseElement = navBarRef.current;
    if (collapseElement && collapseElement.classList.contains("show")) {
      const toggler = document.querySelector(".navbar-toggler");
      toggler?.click();
    }
  };

  function handleClick(event) {
    closeMenu();
    navigate("/contact-us", { state: "other" });
  }

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark innerWidth fixed-top navbar-container"
      style={navbar}
    >
      <span className="navbar-brand d-flex w-50 me-auto">
        <nav className="nav pl-3 lead">
          <Link to={"/#home"} onClick={closeMenu}>
            <img
              src="./nimble-logo3.png"
              alt={logoAlt}
              height={60}
              width={60}
            />
          </Link>
          <span className="nimblebyte">Nimblebyte</span>
        </nav>
      </span>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>

      <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarNav"
        ref={navBarRef}
      >
        <ul className="navbar-nav">
          <li>
            <NavHashLink
              className="nav-link nav-item nav-sublinks"
              style={menuColor2}
              to="/#home"
              onClick={closeMenu}
            >
              <span className="header-feature">Home</span>
            </NavHashLink>
          </li>

          <li>
            <NavHashLink
              className="nav-link nav-item nav-sublinks"
              style={menuColor2}
              to="/#about"
              onClick={closeMenu}
            >
              <span className="header-feature">About</span>
            </NavHashLink>
          </li>

          <li>
            <NavHashLink
              className="nav-link nav-item nav-sublinks"
              style={menuColor2}
              to="/#our-service"
              onClick={closeMenu}
            >
              <span className="header-feature">Services</span>
            </NavHashLink>
          </li>

          <li>
            <NavHashLink
              className="nav-link nav-item nav-sublinks"
              style={menuColor2}
              to="/#portfolio"
              onClick={closeMenu}
            >
              <span className="header-feature">Portfolio</span>
            </NavHashLink>
          </li>

          <li className="nav-item contact-us-style">
            <button
              className="nav-link nav-contact-color contact-us-top contact-more"
              style={contactStyle}
              onClick={handleClick}
            >
              Get Started
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
